(() => {
  const json = JSON.parse(
    document.getElementById("navigation-data").textContent
  );

  // Utility function to check if any descendant link is active
  function isAnyDescendantActive(links) {
    if (!links || links.length === 0) return false;

    return links.some(
      (link) =>
        window.location.pathname.includes(link.url) ||
        isAnyDescendantActive(link.links)
    );
  }

  // Utility function to check if URL matches current page
  function isCurrentPageUrl(url) {
    return window.location.pathname.endsWith(url);
  }

  const buildSideNav = () => {
    const sideNavContainer = document.querySelector(".collection__nav-wrapper");
    if (!sideNavContainer) {
      return;
    }

    // Create the main navigation container
    const navContainer = document.createElement("div");
    navContainer.className = "collection__navigation";

    // Build the navigation structure recursively
    const buildNavItems = (items, parentElement) => {
      items.forEach((item) => {
        const isDecendantActive = isAnyDescendantActive(item.links);
        const isCurrentPage = isCurrentPageUrl(item.url);

        if (item.level !== "1" || (isDecendantActive || isCurrentPage)) {
          // Create link
          const link = document.createElement("a");
          link.href = item.url;
          link.textContent = item.title;

          // Determine the appropriate class based on level
          if (item.level === "1") {
            link.className = "collection__navigation-level-1";
          } else if (item.level === "2") {
            link.className = "collection__navigation-level-2";
          } else if (item.level === "3") {
            link.className = "collection__navigation-level-3";
          }

          if (isCurrentPage) {
            link.classList.add("collection__navigation-current-link");
          }

          // Add link to parent element
          parentElement.appendChild(link);

          // If item has children, recursively build child items
          if (item.links && item.links.length > 0) {
            const shouldShowChildren =
              isCurrentPageUrl(item.url) || isAnyDescendantActive(item.links);

            if (shouldShowChildren) {
              buildNavItems(item.links, parentElement);
            }
          }
        }
      });
    };

    // Initialize the navigation
    buildNavItems(json, navContainer);
    sideNavContainer.appendChild(navContainer);
  };

  // Initialize when DOM is ready
  document.addEventListener("DOMContentLoaded", buildSideNav);
})();
